export default {
  PageFacturae: {
    // Headers and titles
    rectificative_invoice_title: 'FACTURA RECTIFICATIVA',
    rectifies_invoice: 'Rectifica la factura {invoiceNumber} de {invoiceDate}',
    draft_watermark: 'ESBORRANY',

    // QR and verification
    qr_label: 'QR tributari:',
    qr_verifiable: 'Factura verificable a la seu electrònica de l\'AEAT',

    // Invoice numbers and dates
    invoice_number_label: 'Número {documentType}: ',
    external_invoice_number: 'Número factura extern: ',
    invoice_date_label: 'Data {documentType}: ',
    due_date: 'Data de venciment: ',
    operation_date: 'Data operació: ',
    start_date: 'Data inici: ',
    end_date: 'Data final: ',
    signing_date: 'Data signatura: ',

    // Supplier section
    issuer: 'Emissor',
    business_name: 'Raó social: ',
    fiscal_name: 'Nom fiscal: ',
    fiscal_address: 'Domicili fiscal: ',
    nif_cif: 'NIF/CIF: ',
    bank_account: 'Número de compte: ',
    trade_name: 'Nom comercial: ',
    email_label: 'Correu electrònic: ',
    phone_label: 'Telèfon:',
    website_label: 'Web:',

    // Customer section
    receiver: 'Receptor',
    dire_label: 'DIRe:',
    accounting_office: 'Despatx comptable:',
    management_body: 'Òrgan de gestió:',
    processing_unit: 'Unitat tramitadora:',
    proposing_body: 'Òrgan proponent:',

    // Details section
    details: 'Detalls',
    details_of_budget: 'del pressupost',
    details_of_delivery_note: 'de l\'albarà',
    details_of_proforma: 'de la proforma',
    details_of_ticket: 'del tiquet',
    details_of_invoice: 'de la factura',

    // Table headers
    description: 'Descripció',
    total: 'Total',
    quantity: 'Quantitat',
    unit_price: 'Preu unitari',
    discount_percentage: 'Descompte %',
    withholding: 'Retenció',
    total_without_tax: 'Total (sense IVA/IGIC)',

    // Document type headers
    proforma_label: 'Proforma',
    budget_label: 'Pressupost',
    delivery_note_label: 'Albarà',
    date_of_proforma: 'Data de la proforma: ',
    date_of_budget: 'Data del pressupost: ',
    date_of_delivery_note: 'Data de l\'albarà: ',
    file_reference: 'Expedient',
    file_date: 'Data de l\'expedient: ',
    client_reference: 'Referència del client',

    // Totals section
    total_without_discounts: 'Total sense descomptes',
    line_discount: 'Descompte per línia',
    global_discount: 'Descompte global',
    total_without_taxes: 'Total sense impostos',
    total_withholding: 'Total Retenció',
    total_document: 'Total {documentType}',
    withholding_label: 'Retenció: ',
    reimbursable_label: 'Suplert: ',
    total_to_pay: 'Total a pagar',

    // Document types for dynamic text
    invoice: 'Factura',
    budget: 'Pressupost',
    delivery_note: 'Albarà',
    proforma: 'Proforma',
    ticket: 'Tiquet',

    // Footer
    page_number: 'Pàgina {currentPage} de {totalPages}',
    document_info: 'Número {documentType}: {invoiceNumber} ({invoiceDate})',
  }
}